export const CHAT_LIST_PATH = "/menu/chats";

const CHAT_KIND_TO_TAB = {
  event: "events",
  group: "groups",
  direct: "direct",
  support: "all",
};

export function isChatsPath(pathname) {
  return /^\/menu\/chats(?:\/|$)/.test(String(pathname || ""));
}

export function getChatListTabForKind(kind) {
  return CHAT_KIND_TO_TAB[String(kind || "").trim().toLowerCase()] || "all";
}

export function getChatListTabForPath(pathname) {
  const match = String(pathname || "").match(
    /^\/menu\/chats\/(event|group|direct|support)(?:\/|$)/
  );
  return match ? getChatListTabForKind(match[1]) : null;
}

export function buildChatListNavigationOptions({ tab, scrollTop = null } = {}) {
  const parsedScrollTop = Number(scrollTop);
  const hasValidScrollTop =
    scrollTop !== null &&
    scrollTop !== undefined &&
    Number.isFinite(parsedScrollTop) &&
    parsedScrollTop >= 0;
  return {
    replace: true,
    state: {
      openChatTab: tab || "all",
      openChatScrollTop: hasValidScrollTop ? parsedScrollTop : null,
      fromChatCloseTransition: true,
    },
  };
}
